import {useOktaAuth} from "@okta/okta-react";
import {useEffect} from "react";
import {Redirect} from "react-router";

export const Login = () => {
    const {authState, authService} = useOktaAuth();

    useEffect(() => {
        async function authenticate() {
            if (!authState) {
                return;
            }

            if (!authState.isAuthenticated) {
                await authService.login();
            }
        }

        authenticate().then(r => {
        });
    }, [authState]);

    return <Redirect to='/'  />
}